<app-layer-button
  class="position-absolute bottom-7 start-5 z-2"
  (visibilityToggled)="toggleLayerSwitchVisibility()"
>
</app-layer-button>

<div class="position-absolute bottom-7 start-5 z-2" [class.d-none]="!isLayerSelectionVisible">
  <app-layer-config (closed)="close()">
    <div class="d-flex flex-column gap-3 categories">
      <app-bwc-road-segment> </app-bwc-road-segment>
      <app-bwc-weather-prediction
        *hasPermissionAny="[Permissions.RCS_Weather_All_Read]"
      ></app-bwc-weather-prediction>
      <app-bwc-vehicle-data
        *hasPermissionAny="[Permissions.RCS_Weather_All_Read]"
      ></app-bwc-vehicle-data>
    </div>
  </app-layer-config>
</div>
